"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.impersonateTableConf = void 0;
var end2end_1 = require("@hudled/end2end");
var constants_1 = require("containers/TableMaker/constants");
var AccessLevel_1 = __importDefault(require("./CellComponents/AccessLevel"));
var ImpersonateBtn_1 = __importDefault(require("./CellComponents/ImpersonateBtn"));
var SuspendBtn_1 = __importDefault(require("./CellComponents/SuspendBtn"));
var LG = constants_1.CellSize.LG;
exports.impersonateTableConf = {
    extractors: { name: function (user) { return (0, end2end_1.getDisplayName)(user); } },
    cells: [
        { cell: { width: LG, textAlign: 'left' }, field: 'name' },
        { cell: { width: LG }, field: 'email' },
        { cell: { width: LG }, field: 'accessLevel', renderComponent: AccessLevel_1.default },
        { cell: { width: LG }, key: 'impersonate', renderComponent: ImpersonateBtn_1.default },
        { cell: { width: LG }, key: 'suspend', renderComponent: SuspendBtn_1.default },
    ],
};
